import { Component  } from '@angular/core';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { NavController } from 'ionic-angular';
import { LoginPage } from '../../pages/login/login';
import { HomePage } from '../../pages/home/home';
import { MapasPage } from '../../pages/mapas/mapas';
import { Nav, Platform } from 'ionic-angular';
import { ListPage } from '../../pages/list/list';
import { InformesPage } from '../../pages/informes/informes';
import { AiAgentPage } from '../../pages/ai-agent/ai-agent';


@Component({
  selector: 'cabecera',
  templateUrl: 'cabecera.html'
})
export class CabeceraComponent {
  
  avisos;
  subuser: any[] = [];

  text: string;
  salir : any;
  caminologo;
  constructor(
  	public navCtrl: NavController,
    public funciones:FuncionesProvider,
  	public variablesglobales:VariablesProvider

) {
  this.cargarSubempresas();

    

  this.funciones.obtenervalor("avisos","aviso","*").then(
    respuesta => {
      this.avisos = respuesta; 



      //console.log(this.avisos['0'].VALOR);
      
    });



    this.caminologo ="http://www.panel-control.com/picademo/logos/"  + this.variablesglobales.LOGOGLOBAL;
  }

  private cargarSubempresas(): void {
    const principal = String(
      this.variablesglobales.emailoriginal ||
      this.variablesglobales.CLIENTES_RAZSOCIAL ||
      this.variablesglobales.username || ''
    ).trim();
    if (!principal) { return; }

    this.funciones.getsubuser(principal).then((respuesta: any) => {
      const vistas: any[] = [];
      const existentes: any = {};
      (Array.isArray(respuesta) ? respuesta : []).forEach((fila: any) => {
        // Compatibilidad con instalaciones que guardaron varios hijos en una misma celda.
        String((fila && (fila.USER_HIJO || fila.user_hijo)) || '').split(/[;,|]/).forEach((valor: string) => {
          const nombre = String(valor || '').trim();
          const clave = nombre.toLowerCase();
          if (nombre && !existentes[clave] && clave !== principal.toLowerCase()) {
            existentes[clave] = true;
            vistas.push({ USER_HIJO: nombre });
          }
        });
      });
      this.subuser = vistas;
    }).catch(() => this.subuser = []);
  }

  logoNoDisponible(event: any): void {
    const imagen: any = event && event.target;
    if (imagen && imagen.src.indexOf('assets/imgs/logo.png') < 0) {
      imagen.src = 'assets/imgs/logo.png';
    }
  }
  
  inicio(){
      this.navCtrl.push(HomePage); 
  }
 openmapa(){
    this.variablesglobales.usuariomapa="todos";
    this.variablesglobales.usuariomapaid="";
    this.navCtrl.push(MapasPage);
  }

  informes(){
    this.navCtrl.push(InformesPage);
  }


  cambiavalor(valor){

    this.variablesglobales.CLIENTES_RAZSOCIAL = valor;


    this.navCtrl.push(ListPage);

  }


  
  informesia(){

    this.navCtrl.push(AiAgentPage);

  }


  salirdelasesion(){

  	this.funciones.cerrarsesion().then(
      data => {
      	
      	this.salir = "no";
        
        this.salir = data;
     	
     	if (this.salir=true){
     		
     		this.navCtrl.push(LoginPage); 
    	}
        
       })
      .catch(
        error => {
          console.log(error);
        }
      )
  }

 goBack(){
    this.navCtrl.pop();
  }


  cambiamodo() {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
      if (this.variablesglobales.MODO=='real') {
        this.variablesglobales.MODO='pruebas';
        this.navCtrl.push(ListPage);
      }else{
        this.variablesglobales.MODO='real';
        this.navCtrl.push(ListPage);
      }
    
  }

}



// WEBPACK FOOTER //
// ./src/components/cabecera/cabecera.ts